import React from 'react';
import { Reveal } from './Reveal';
type Volume = {
  number: string;
  title: string;
  description: string;
  tags: string[];
  featured?: boolean;
};
const volumes: Volume[] = [{
  number: 'VOLUME 01',
  title: '🌊 The Complete Reiki Program',
  description: 'Learn to channel energy, activate your 7 chakras, and establish a daily practice. Includes the 21-day activation protocol and foundational self-Reiki techniques.',
  tags: ['Reiki Fundamentals', 'Daily Practice', 'Ready to Use']
}, {
  number: 'VOLUME 02',
  title: '⚙️ Advanced Practitioner Techniques',
  description: 'Master distance healing, energetic diagnostics, chakra work, and professional session protocols. Work with trauma, blocks, and complex client presentations.',
  tags: ['Advanced Methods', 'Client Protocols', 'Professional Practice'],
  featured: true
}, {
  number: 'VOLUME 03',
  title: '👑 Next-Level Practice Mastery',
  description: 'Step into Reiki Master level. Learn attunements, ceremonial protocols, and how to build your own Reiki school or certification program.',
  tags: ['Attunements', 'Master Symbols', 'Train Others']
}, {
  number: 'VOLUME 04',
  title: '🗺️ The Therapeutic Body Map',
  description: 'Decode the emotional and energetic roots beneath physical symptoms. Understand what the body is communicating through pain and illness.',
  tags: ['Symptom-Emotion Guide', 'Diagnostic Tools', 'Healing Protocols'],
  featured: true
}, {
  number: 'VOLUME 05',
  title: '📋 Professional Session Protocols',
  description: 'Structure perfect sessions from intake to closure. Includes scripts, conversation frameworks, documentation templates, and client relationship management.',
  tags: ['Session Templates', 'Scripts & Language', 'Professional Forms']
}, {
  number: 'VOLUME 06',
  title: '✨ 21-Day Energy Expansion',
  description: 'Your personal transformation journey. Integrate everything you’ve learned. Expand your capacity and anchor your practice in daily life.',
  tags: ['30-Day Integration', 'Personal Practices', 'Expansion Rituals']
}];
export function Modules() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-146" data-mp="28oi1a778vrei">
      <div className="mx-auto max-w-6xl" data-id="element-147" data-mp="2cpbn8v14mw4r">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-148" data-mp="2cqcxixabjelf">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-149" data-mp="30ew67dxa5te1">
            📚 6 Complete <span className="text-sage" data-id="element-150" data-mp="30h8mlmne3voz">Professional Volumes</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-151" data-mp="35d7gfprhm5ws">
            Every protocol covered. Every technique explained. Every tool ready to print and use
            today.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-152" data-mp="2vmmlccb0vjim">
          {volumes.map((volume, index) => <Reveal key={volume.number} delay={index % 2 * 0.06} className="h-full" data-id="element-153" data-mp="3jc78l7e7l2xp" data-mpi={index}>
              <article className={`flex h-full flex-col rounded-2xl border bg-surface p-8 shadow-premium ${volume.featured ? 'border-amber/50' : 'border-navy/10'}`} data-id="element-154" data-mp="3o5a1ddb5w8cu">
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-sage" data-id="element-155" data-mp="17okg72692q2y">
                  {volume.number}
                </p>
                <h3 className="mt-4 font-serif text-2xl leading-tight text-navy" data-id="element-156" data-mp="1hfybsyv2z5qt">
                  {volume.title}
                </h3>
                <p className="mt-4 flex-1 text-sm leading-7 text-slate" data-id="element-157" data-mp="tqvvpvg3hkyf">{volume.description}</p>
                <ul className="mt-6 flex flex-wrap gap-2" data-id="element-158" data-mp="ot3v8d1dwqim">
                  {volume.tags.map(tag => <li key={tag} className="rounded-full bg-amber-pale px-3 py-1.5 text-xs font-semibold text-navy" data-id="element-159" data-mp="13q4mygjkslh3">
                      {tag}
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}